import { Instance, types } from 'mobx-state-tree';

import GradeType from '../GradeTypes/GradeType';

const StudentGrade = types
	.model('StudentGrade', {
		grade: types.optional(types.string, ''),
		grade_type: types.maybeNull(GradeType),
		gradebook_type: types.optional(types.string, ''),
		topic_schedule_name: types.optional(types.string, ''),
		lesson: types.maybe(
			types.model({
				assessment_type_id: types.maybeNull(types.number),
				weight: types.maybeNull(types.optional(types.string, '')),
			}),
		),
		final_comment: types.maybeNull(types.string),
		program: types.maybeNull(
			types.model({
				id: types.maybeNull(types.number),
				name: types.optional(types.string, ''),
			}),
		),
	})
	.views((self) => ({
		get isThematic() {
			return self.gradebook_type === 'topic';
		},
	}));

export default StudentGrade;

export interface IStudentGradeModel extends Instance<typeof StudentGrade> {}
